const SDK_VERSION = '7.77.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
